import { render, staticRenderFns } from "./FormPostSeo.vue?vue&type=template&id=11b568b8&scoped=true&lang=pug&"
import script from "./FormPostSeo.vue?vue&type=script&lang=js&"
export * from "./FormPostSeo.vue?vue&type=script&lang=js&"
import style0 from "./FormPostSeo.vue?vue&type=style&index=0&id=11b568b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b568b8",
  null
  
)

export default component.exports